import React, { useEffect } from 'react'
import { Provider } from 'react-redux'
import { store } from '../../../Redux/store'
import { onAuthStateChanged } from 'firebase/auth'
import { auth } from '../../../config/firebase'
import { checkLogin } from '../../../Redux/auth/authSlice'
import ProtectedRoutes from '../ProtectedRoutes'

const index = () => {
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      store.dispatch(checkLogin(user))
    })

    return () => {
      unsubscribe()
    }
  }, [])

  return (
    <Provider store={store}>
      <ProtectedRoutes />
    </Provider>
  )
}

export default index
